import TaskLaneCard from './TaskLaneCard';

export default TaskLaneCard;
